export default __webpack_public_path__ + "static/media/english-to-tagalog-screenshot-03.990b1873.png";